
<template>
  <van-tabbar v-model="active">
    <van-tabbar-item icon="home-o" to="/index/home">首页</van-tabbar-item>
    <van-tabbar-item icon="user-circle-o" to="/index/my">我的</van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { ref } from "vue";
export default {
  setup() {
    const active = ref(window.location.hash.indexOf("home")>0?0:1);
    // const active = ref(myStorage.get("active") || 0);
    // watchEffect(() => myStorage.set("active", active.value));
    return {
      active,
    };
  },
};
</script>

